<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :max-width="100"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :append-icon="mdiClockStart"
        :class="inputClass"
        readonly
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
      />
    </template>
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="hours"
          label="Hours"
          type="number"
          step="1"
          min="0"
          hide-details
        />
        <v-text-field
          v-model="minutes"
          label="Minutes"
          type="number"
          step="1"
          min="0"
          max="59"
          hide-details
        />
        <v-text-field
          v-model="secconds"
          label="Seconds"
          type="number"
          step="1"
          min="0"
          max="59"
          hide-details
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiClockStart } from '@mdi/js'
export default {
  props: {
    inputClass: {
      type: [String, Object],
      default: ''
    },
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mdiClockStart,
      menu: false,
      timeoutId: null,
      regexp: /(\d+):(\d+):(\d+)/
    }
  },
  computed: {
    hours: {
      get () {
        const [hours] = this.value.match(/(\d+)/g).map(val => parseInt(val))
        return hours
      },
      set (val) {
        val = parseInt(val) || 0
        const newTime = this.value.replace(this.regexp, `${String(val).padStart(2, '0')}:$2:$3`)
        this.updateTime((newTime) => {
          this.$emit('input', newTime)
        }, 500)(newTime)
      }
    },
    minutes: {
      get () {
        const [, minutes] = this.value.match(/(\d+)/g).map(val => parseInt(val))
        return minutes
      },
      set (val) {
        val = parseInt(val) || 0
        const newTime = this.value.replace(this.regexp, `$1:${String(val).padStart(2, '0')}:$3`)
        this.updateTime((newTime) => {
          this.$emit('input', newTime)
        }, 500)(newTime)
      }
    },
    secconds: {
      get () {
        const [,, seconds] = this.value.match(/(\d+)/g).map(val => parseInt(val))
        return seconds
      },
      set (val) {
        val = parseInt(val) || 0
        const newTime = this.value.replace(this.regexp, `$1:$2:${String(val).padStart(2, '0')}`)
        this.updateTime((newTime) => {
          this.$emit('input', newTime)
        }, 500)(newTime)
      }
    }
  },
  methods: {
    updateTime (callback, wait) {
      return (...args) => {
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId)
        }

        this.timeoutId = setTimeout(() => {
          callback(...args)
        }, wait)
      }
    }
  }
}
</script>
